module.exports = __webpack_public_path__ + "static/media/IMG_20180203_103220.c2f03c34.jpg";